import { compose } from "redux";
import React, { PureComponent } from "react";
import { Grid, Box } from "@material-ui/core";
import PrintIcon from "@material-ui/icons/Print";

import { ReportHeaderBase } from "altus-ui-components";
import { ReportHeaderIconButton } from "altus-ui-components";

class ScheduleOverridesReportHeader extends PureComponent {
  render() {
    return (
      <Box displayPrint="none">
        <ReportHeaderBase>
          <Grid xs item container spacing={2} wrap="nowrap" alignItems="center">
            <Grid item xs />
            <Grid item>
              <ReportHeaderIconButton
                title="Print"
                onClick={window.print}
                Icon={PrintIcon}
              />
            </Grid>
          </Grid>
        </ReportHeaderBase>
      </Box>
    );
  }
}

export default compose()(ScheduleOverridesReportHeader);
